import { c as _c } from "react/compiler-runtime";
import type { Theme } from '@onefootprint/design-tokens';
import type { DecisionStatus, UserTimelineEventOnboardingDecision } from '@onefootprint/request-types/dashboard';
import { ActorKind, WorkflowKind } from '@onefootprint/types';
import type { TimelinePlaybook } from '@onefootprint/types/src/data/onboarding-decision';
import { Trans, useTranslation } from 'react-i18next';
import { OnboardingTraceLink } from '@/components';
import Actor from '../actor';
type OnboardingDecisionEventHeaderProps = {
  data: UserTimelineEventOnboardingDecision['data'];
  playbook?: TimelinePlaybook;
};
const OnboardingDecisionEventHeader = t0 => {
  const $ = _c(42);
  const {
    data,
    playbook
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.onboardingDecisionEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const {
    decision: t2,
    workflowSource
  } = data;
  const {
    workflowKind,
    source,
    status,
    clearedManualReviews
  } = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = _temp;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== clearedManualReviews?.length || $[3] !== data.decision || $[4] !== playbook || $[5] !== source || $[6] !== status || $[7] !== t || $[8] !== workflowKind || $[9] !== workflowSource) {
    t9 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const statusToText = {
        fail: t(t3),
        pass: t(_temp2),
        none: t(_temp3)
      };
      let t10;
      if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = {
          fail: "error",
          pass: "success",
          none: "neutral"
        };
        $[16] = t10;
      } else {
        t10 = $[16];
      }
      const statusToColor = t10;
      const color = statusToColor[status];
      if (source.kind === ActorKind.footprint && workflowKind === WorkflowKind.Document) {
        const t11 = `text-label-2 text-${color}`;
        let t12;
        if ($[17] !== t) {
          t12 = t(_temp4);
          $[17] = t;
          $[18] = t12;
        } else {
          t12 = $[18];
        }
        let t13;
        if ($[19] !== t11 || $[20] !== t12) {
          t13 = <div className="flex flex-row items-center gap-1"><div className="flex items-center" data-testid="onboarding-decision-event-header"><p className={t11}>{t12}</p></div></div>;
          $[19] = t11;
          $[20] = t12;
          $[21] = t13;
        } else {
          t13 = $[21];
        }
        t9 = t13;
        break bb0;
      }
      if (source.kind === ActorKind.footprint && playbook) {
        let outcome = "";
        if (status === "pass" || status === "fail") {
          outcome = t(_temp5, {
            status: statusToText[status]
          });
        }
        let t11;
        if ($[22] !== data.decision.onboardingId || $[23] !== playbook) {
          t11 = {
            playbook: <OnboardingTraceLink onboardingId={data.decision.onboardingId} playbook={playbook} />
          };
          $[22] = data.decision.onboardingId;
          $[23] = playbook;
          $[24] = t11;
        } else {
          t11 = $[24];
        }
        const t12 = <p className={`md:flex md:gap-1 md:whitespace-nowrap text-label-2 text-${color}`}><Trans ns="entity-details" i18nKey={workflowSource === "tenant" ? _temp6 : _temp7} values={{
            outcome
          }} components={t11} /></p>;
        let t13;
        if ($[25] !== t12) {
          t13 = <div className="flex flex-row items-center gap-1 flex-wrap"><div className="flex items-center" data-testid="onboarding-decision-event-header">{t12}</div></div>;
          $[25] = t12;
          $[26] = t13;
        } else {
          t13 = $[26];
        }
        t9 = t13;
        break bb0;
      }
      if (status === "none" && clearedManualReviews?.length) {
        let t11;
        if ($[27] !== source) {
          t11 = <div className="flex flex-row items-center gap-1"><div className="flex items-center" data-testid="onboarding-decision-event-header"><p className="text-body-2 text-tertiary"><Trans ns="entity-details" i18nKey={_temp8} components={{
                  actor: <Actor actor={source} />
                }} /></p></div></div>;
          $[27] = source;
          $[28] = t11;
        } else {
          t11 = $[28];
        }
        t9 = t11;
        break bb0;
      }
      t8 = "flex flex-row items-center gap-1";
      t6 = "flex flex-wrap items-center gap-1 md:flex-nowrap";
      t7 = "onboarding-decision-event-header";
      t4 = `text-label-2 text-${color}`;
      t5 = t(_temp9, {
        decision: statusToText[status]
      });
    }
    $[2] = clearedManualReviews?.length;
    $[3] = data.decision;
    $[4] = playbook;
    $[5] = source;
    $[6] = status;
    $[7] = t;
    $[8] = workflowKind;
    $[9] = workflowSource;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
    t9 = $[15];
  }
  if (t9 !== Symbol.for("react.early_return_sentinel")) {
    return t9;
  }
  let t10;
  if ($[29] !== t4 || $[30] !== t5) {
    t10 = <span className={t4}>{t5}</span>;
    $[29] = t4;
    $[30] = t5;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== source) {
    t11 = <Actor actor={source} />;
    $[32] = source;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t6 || $[37] !== t7) {
    t12 = <div className={t6} data-testid={t7}>{t10}{t11}</div>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t6;
    $[37] = t7;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== t12 || $[40] !== t8) {
    t13 = <div className={t8}>{t12}</div>;
    $[39] = t12;
    $[40] = t8;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  return t13;
};
export default OnboardingDecisionEventHeader;
function _temp($) {
  return $.decisionStatus.fail;
}
function _temp2($_0) {
  return $_0.decisionStatus.pass;
}
function _temp3($_1) {
  return $_1.decisionStatus.none;
}
function _temp4($_2) {
  return $_2.uploadedDocs;
}
function _temp5($_3) {
  return $_3.withOutcome;
}
function _temp6($_4) {
  return $_4.auditTrail.timeline.onboardingDecisionEvent.ranPlaybook;
}
function _temp7($_5) {
  return $_5.auditTrail.timeline.onboardingDecisionEvent.onboardedOnto;
}
function _temp8($_6) {
  return $_6.auditTrail.timeline.onboardingDecisionEvent.clearedReviews.title;
}
function _temp9($_7) {
  return $_7.humanDecision.title;
}